import { render, staticRenderFns } from "./IncomingOrders.vue?vue&type=template&id=683468e9"
import script from "./IncomingOrders.vue?vue&type=script&lang=js"
export * from "./IncomingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports